// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__35Dc7","resendInfoText":"OnGoingPaymentBox_resendInfoText__2hZ73"};